<template>
	<div class="form_modal_popup learner_profile_questions">
    
    <b-modal class="h-100 d-inline-block" id="add-prog-career-interest-popup" ref="addProgCarIntModal" size="xl" :header-bg-variant="'light'" hide-footer no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header" class="header-section w-100">
          <div class="popup_head_txt float-left" style="width: calc(100% - 120px);">
            <span>Tell us more about yourself</span>
          </div>
          <div class="float-right">
            <button class="btn_close" aria-label="close" @click="cancelAddProgCarIntModal(true)">
              <span class="ic-close"></span>
            </button>
            <template v-if="questions.length > 0">
              <b-button class="float-right mr-3 mt-1" @click="saveProgCarInterest">done</b-button>
            </template>
          </div>

        </div>

        <div class="modal_content">

          <div class="row fld_row" v-for="(question, i) in questions">
            <!--
            <div class="col-2 ic_container">
              <div class="ic" :class="'ic-' + question.icon"></div>
            </div>
            -->
            <div class="col-12 qus_container">
              <div class="row q_row">

                <div class="col-12 fld_label">
                  <span class="q_title">{{question.title}}</span>
                  <template v-if="question.helpText">
                    <span :id="'quetionHelpText-' + i" class="help_sec" style="float: none;">
                      <span class="ic ic8-info5" style="float: none;"></span>
                    </span>
                    <b-popover :target="'quetionHelpText-' + i" container="quetionHelpTextPopup" triggers="hover">
                      <div class="popup_content">
                        {{question.helpText}}
                      </div>
                    </b-popover>
                    <div :id="'quetionHelpTextPopup_' + i" class="help_popup_container"></div>
                  </template>
                </div>

                <div class="col-12 fld_val" v-if="question.description">{{question.description}}</div>

                <template v-if="question.type === 'SELECT'">
                  <template v-if="question.optionType === 'DYNAMIC'">
                    <div class="col-12 fld_val">
                      <autocomplete
                        :ref="`autocomplete_${i}`"
                        :source="question.options"
                        :placeholder="getDynamicSelectPlaceholder(question)"
                        :aria-label="getDynamicSelectPlaceholder(question)"
                        input-class="form-control"
                        :results-display="getDynamicSelectFormattedDisplay"
                        @selected="dynamicSelectAfterSelected($event, question, i)">
                      </autocomplete>
                    </div>
                  </template>
                  <template v-if="question.optionType === 'STATIC'">
                    <div class="col-12 fld_val">
                      <v-select
                        class="select-field"
                        v-model="question.response"
                        :options="question.options"
                        label="value"
                        :placeholder="question.preText"
                        :aria-label="question.preText"
                        :clearable="true"
                        @selected="selectedItem($event, question, i)">
                      </v-select>
                    </div>
                    <template v-if="question.response ==='Other' || (question.response && question.response.value && question.response.value ==='Other') ">
                      <div class="col-12 fld_label"><br/>
                          <div class="float-left">Type your response </div>
                      </div>
                      <div class="col-12 fld_val">
                        <input
                          type=text
                          v-model="question.other"
                          aria-label="Question Response"
                          class="q_other">
                      </div>
                    </template>
                  </template>
                  <template v-if="question.optionType === 'STATIC-MULTI'">
                    <div class="col-12 fld_val multiselect_tags_container">
                        <multiselect
                          :placeholder="getDynamicSelectPlaceholder(question)"
                          :aria-label="getDynamicSelectPlaceholder(question)"
                          v-model="question.selectedResponses"
                          :options="question.options"
                          multiple="true"
                          :close-on-select="false">
                        </multiselect>
                        <!--
                        <div class="selected_entity_container" v-if="question.selectedResponses.length > 0">
                          <div class="selected_entity" v-for="sR in question.selectedResponses">
                            <span :title="sR">{{sR}}</span>
                          </div>
                        </div>

                      <vue-multi-select
                        v-model="question.selectedResponses"
                        search
                        :btnLabel="getDynamicMultiSelectPlaceholder(question)"
                        :selectOptions="question.options"
                        :options="options"
                        max-height="100"
                        class="multi_select_dropdown"
                        closeOnSelect="true"
                        optionHeight="100"
                        selectLabel="add"
                      />
                      -->
                    </div>
                  </template>

                  <template v-if="question.optionType === 'DYNAMIC-MULTI'">
                    <div class="col-12 fld_val multiselect_tags_container">
                      <!--
                      <template v-if="question.optionSource === 'CAREER'">
                        <div class="selected_entity_container mb-2" v-if="question.selectedResponses.length > 0">
                          <div class="selected_entity" v-for="sR in question.selectedResponses">
                            <span :title="sR.name">{{sR.name}}</span>
                          </div>
                          <div class="no_info" v-if="(question.selectedResponses).length === 0">
                            No career interest added
                          </div>
                        </div>
                      </template>

                      <vue-multi-select v-if="question.optionSource === 'CAREER'"
                        v-model="question.selectedResponses"
                        ref="multiSelectCareer"
                        :btnLabel="getDynamicMultiSelectPlaceholder(question)"
                        :selectOptions="question.options"
                        :options="options"
                        max-height="100"
                        class="multi_select_dropdown"
                        optionHeight="100"
                        selectLabel="add"
                      />
                      -->
                      <multiselect v-if="question.optionSource === 'CAREER'"
                        :placeholder="getDynamicSelectPlaceholder(question)"
                        :aria-label="getDynamicSelectPlaceholder(question)"
                        v-model="question.selectedResponses"
                        :options="question.options" label="name"
                        track-by="name" multiple="true"
                        :close-on-select="false">
                      </multiselect>
                        <!--
                      <template v-if="question.optionSource === 'PROGRAM'">
                        <div class="selected_entity_container mb-2" v-if="question.selectedResponses.length > 0">
                          <div class="selected_entity" v-for="sR in question.selectedResponses">
                            <span :title="sR.name">{{sR.name}}</span>
                          </div>
                          <div class="no_info" v-if="(question.selectedResponses).length === 0">
                            No program interest added
                          </div>
                        </div>
                      </template>

                      <vue-multi-select v-if="question.optionSource === 'PROGRAM'"
                        :btnLabel="getDynamicMultiSelectPlaceholder(question)"
                        ref="multiSelectProgram"
                        v-model="question.selectedResponses"
                        :selectOptions="question.options"
                        :options="options"
                        max-height="100"
                        class="multi_select_dropdown"
                        optionHeight="100"
                        selectLabel="add"
                      />
                      -->
                      <multiselect v-if="question.optionSource === 'PROGRAM'"
                        :placeholder="getDynamicSelectPlaceholder(question)"
                        :aria-label="getDynamicSelectPlaceholder(question)"
                        v-model="question.selectedResponses"
                        :options="question.options"
                        label="name"
                        track-by="name"
                        :multiple="true"
                        :close-on-select="false">
                      </multiselect>
                      <!--
                      <autocomplete
                        :ref="`autocomplete_${i}`"
                        :source="question.options"
                        :placeholder="getDynamicSelectPlaceholder(question)"
                        input-class="form-control"
                        :results-display="getDynamicSelectFormattedDisplay"
                        @selected="dynamicSelectAfterSelected($event, question, i)">
                      </autocomplete>
                      -->
                    </div>
                  </template>
                </template>
                <template v-else-if="question.type === 'MULTI_LINE_TEXT'">
                  <div class="col-12 fld_val">
                    <textarea
                      :rows="question.lineCount"
                      cols="83"
                      :maxlength="question.responseLimit"
                      :placeholder="question.preText"
                      :aria-label="question.preText"
                      v-model.trim="question.response">
                    </textarea>
                  </div>
                </template>

              </div>
            </div>



          </div>
        </div>
    </b-modal>

  </div>
</template>

<script>
  import _ from 'lodash'
	import { mapActions } from 'vuex'
  import Autocomplete from 'vuejs-auto-complete'
  import VueMultiSelect from 'vue-multi-select';
  import 'vue-multi-select/dist/lib/vue-multi-select.css';
  import Multiselect from 'vue-multiselect'

	export default {
		name: 'learner-profile-question',
    components: {
      Autocomplete,
      VueMultiSelect,
      Multiselect
    },
		data: () => {
			return {
        careers: [],
        programs: [],
        questions: [],
        options: {
          multi: true
        },
				isOpen: false
			}
		},
    async created () {
      let careerResult = await this.loadCareerForProfile({page: 0, count: 5000, name: ''})
      this.careers = careerResult.content.sort((a, b) => (a.name >= b.name) ? 1 : -1)
      let programResult = await this.loadMajorMinors({page: 0, count: 5000, name: '', skipMinor: false})
      this.programs = programResult.content.sort((a, b) => (a.name >= b.name) ? 1 : -1)
    },
    mounted () {
      this.populateProfileQuestionData()
    },
    methods: {
			...mapActions([
        'loadGeoIds',
        'loadCareerForProfile',
        'loadMajorMinors',
        'loadQuestionsForGroup',
        'loadSaveUserProfileAndAnswer'
	    ]),
      getCareerValue (option) {
          return option.pragyaSoc
      },
      getProgramValue (option) {
        return option.code
      },
      populateProfileQuestionData () {
        this.questions = []
        this.loadQuestionsForGroup('PROFILE_POPUP_1').then(questions => {
          if (questions && questions.length > 0) {
            questions.forEach(question => {
              if ((question.type === 'SELECT')  || (question.type === 'MULTI_LINE_TEXT')) {
                question.response = (question.responses && question.responses.length > 0) ? question.responses[0] : ''
              }
              if (question.optionType === 'STATIC') {
                if(question.response ==='Other'){
                    question.other = question.responses[1]
                }
              }
              if (question.optionType === 'STATIC-MULTI') {
                  question.selectedResponses = []
                  for (let i = 0; i < question.options.length; i++) {
                    let option = question.options[i].value
                    question.options[i] = option
                    if (question.responses && (question.responses.indexOf(option) > -1 )) {
                      question.selectedResponses.push(option)
                    }
                  }
              }
              if (question.optionType === 'DYNAMIC' || question.optionType === 'DYNAMIC-MULTI') {
                if (question.optionSource === 'CAREER') {
                  question.options = this.careers
                  question.selectedResponses = []
                  for (let i = 0; i < question.options.length; i++) {
                    let option = question.options[i]
                    if (question.responses && (question.responses.indexOf(option.code) > -1 || question.responses.indexOf(option.pragyaSoc) > -1)) {
                      question.selectedResponses.push(option)
                    }
                  }
                } else if (question.optionSource === 'PROGRAM') {
                  question.options = this.programs
                  question.selectedResponses = []
                  for (let i = 0; i < question.options.length; i++) {
                    let option = question.options[i]
                    if (question.responses && question.responses.indexOf(option.code) > -1) {
                      question.selectedResponses.push(option)
                    }
                  }
                } else if ((question.optionSource === 'SMA') || (question.optionSource === 'STATE') || (question.optionSource === 'SMA,STATE')) {
                  this.loadGeoIds().then(resp => {
                    let msaGeoIds = Object.values(resp.msaGeoIds)
                    let stateGeoIds = Object.values(resp.stateGeoIds)
                    let msaStateGeoIds = msaGeoIds.concat(stateGeoIds)
                    if (question.optionSource === 'SMA') {
                      question.options = msaGeoIds.sort()
                    } else if (question.optionSource === 'STATE') {
                      question.options = stateGeoIds.sort()
                    } else if (question.optionSource === 'SMA,STATE') {
                      question.options = msaStateGeoIds.sort()
                    }
                  })
                }
              }
              this.addQuestion(question)
            })
          }
        })
      },
      addQuestion (newQuestion) {
        let matched = _.find(this.questions, (question) => {
          return (newQuestion.uuid === question.uuid)
        })
        if (!matched) {
          this.questions.push(newQuestion)
        }
      },
      cancelAddProgCarIntModal (isCanceled) {
        if (isCanceled) {
          this.populateProfileQuestionData()
        }
        this.$refs.addProgCarIntModal.hide()
      },
	    showAddProgCarIntModal () {
        this.populateProfileQuestionData()
        setTimeout(() => {
          this.$refs.addProgCarIntModal.show()
        }, 250)
	    },
	    async saveProgCarInterest () {
        let questions = _.cloneDeep(this.questions)
        questions.forEach(question => {
          if (question.type === 'MULTI_LINE_TEXT') {
            let response = $.trim(question.response)
            if (response.length > 0) {
              question.responses = [response]
            }
          }
          if (question.type === 'SELECT' && question.optionType ==='STATIC') {
              if(question.response && question.response.value){
                question.response = question.response.value
              }
              question.responses = [question.response]
              if(question.response === 'Other' && question.other){
                question.responses[1] = question.other
              }
          }
          if (question.type === 'SELECT' && question.optionType ==='STATIC-MULTI' && question.selectedResponses) {
            question.responses = []
            question.selectedResponses.forEach((item, i) => {
              question.responses.push(item)
            })
          }
          if (question.optionSource === 'CAREER' && question.selectedResponses) {
            question.responses = []
            question.selectedResponses.forEach((item, i) => {
              question.responses.push(item.pragyaSoc)
            })
            delete question.selectedResponses
          }
          if (question.optionSource === 'PROGRAM' && question.selectedResponses) {
            question.responses = []
            question.selectedResponses.forEach((item, i) => {
              question.responses.push(item.code)
            })
            delete question.selectedResponses
          }
          delete question.options
        })
        let resp = await this.loadSaveUserProfileAndAnswer({questions: questions})
        if (resp) {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Your profile updated successfully.'
          })
          setTimeout(() => {
            this.$root.$emit('reloadLearnerDashboard')
          }, 0)
        }
        this.cancelAddProgCarIntModal()
	    },
      getDynamicSelectPlaceholder (question) {
        return question.response || question.preText
      },
      getDynamicMultiSelectPlaceholder (question) {
        let value = question.preText
        return values => value
      },
      getDynamicSelectFormattedDisplay (item) {
        return item.name || item
      },
      dynamicSelectAfterSelected (item, question, i) {
        let responses = []
        question.response = item.display
        if (_.isObject(item.selectedObject)) {
          let value = (item.selectedObject.pragyaSoc || item.selectedObject.code)
          responses = [value]
        } else {
          responses = [item.display]
        }
        question.responses = responses
        let ref = 'autocomplete_' + i
        this.$refs[ref][0].clear()
      }
		}
	}
</script>

<style scoped>
  .popup_head_txt {
    font-size: 1.4rem;
    font-weight: 600;
  }
  .clearButton {
    display: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProfileQuestion.vue